/* eslint-disable jsx-a11y/alt-text */
import { Grid, Typography, Box, Divider } from '@material-ui/core';
import React from 'react';
import {
  currencyFormatter,
  simpleDateFormatter,
  simpleDateFormatterData,
  opTypeFormatter,
  moneyFormatEmpty,
} from '../Shared/colorFormat';
import './index.css';

export const renderAccountHeaderCell = (d: any, xs: any, p = 0) => (
  <Grid item xs={xs}>
    <Typography
      variant="caption"
      color="secondary"
      style={{ padding: p, fontWeight: 'bold' }}
    >
      {d}
    </Typography>
  </Grid>
);

export const renderAccountCell = (d: any, xs: any, p = 0) => (
  <Grid item xs={xs}>
    <Typography variant="caption" style={{ padding: p }}>
      {d}
    </Typography>
  </Grid>
);

export const renderAccountCellbalance = (d: any, xs: any, p = 0) => (
  <Grid item xs={xs}>
    <Typography variant="caption" style={{ padding: p, fontWeight: 'bold' }}>
      {d}
    </Typography>
  </Grid>
);

export const renderAccount = ({ pacc, isRTL, p = 0 }: any) => {
  const { accounts } = pacc;
  return (
    <Box style={{ backgroundColor: '#eee' }}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box style={{ backgroundColor: '#fff' }}>
            <Grid container spacing={0}>
              {accounts.map((acc: any) => {
                const {
                  accCode,
                  accName,
                  accNameAr,
                  credit,
                  debit,
                  main,
                  sub,
                  rc,
                  rd,
                } = acc;
                const name = isRTL ? accNameAr : accName;
                return (
                  <>
                    <Grid item xs={12}>
                      <Divider></Divider>
                    </Grid>
                    {renderAccountCell(accCode, 1, p)}
                    {renderAccountCell(main, 2, p)}
                    {renderAccountCell(sub, 2, p)}
                    {renderAccountCell(name, 2, p)}
                    {renderAccountCell(moneyFormatEmpty(debit), 1, p)}
                    {renderAccountCell(moneyFormatEmpty(credit), 1, p)}
                    {renderAccountCellbalance(moneyFormatEmpty(rd), 2, p)}
                    {renderAccountCellbalance(moneyFormatEmpty(rc), 1, p)}
                  </>
                );
              })}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export class BalanceReportPrint extends React.PureComponent<any, any> {
  renderItemHeaderTable = (isRTL: boolean) => {
    return (
      <tr style={{ fontSize: 12 }}>
        <th>{isRTL ? 'التاريخ' : 'Date'}</th>
        <th>{isRTL ? 'الوثيقة' : 'Document'}</th>
        <th>{isRTL ? 'الحساب' : 'Account'}</th>
        <th>{isRTL ? 'مدين' : 'Debit'}</th>
        <th>{isRTL ? 'دائن' : 'Credit'}</th>
        <th>{isRTL ? 'الرصيد' : 'Balance'}</th>
      </tr>
    );
  };
  renderItemTable = (item: any, isRTL: any) => {
    return (
      <tr style={{ fontSize: 12 }}>
        <td style={{ textAlign: 'center' }}>
          {simpleDateFormatter(item?.opTime)}
        </td>
        <td style={{ textAlign: 'center' }}>
          {opTypeFormatter({ value: item?.opType })} {item?.opDocNo}
        </td>
        <td style={{ textAlign: 'center' }}>
          {isRTL ? item?.accNameAr : item?.accName}
        </td>
        <td>{currencyFormatter({ value: item?.debit })}</td>
        <td>{currencyFormatter({ value: item?.credit })}</td>
        <td>{currencyFormatter({ value: item?.rased })}</td>
      </tr>
    );
  };

  renderFrontTop = ({ account, start, end, rased, isRTL }: any) => {
    return (
      <Grid container spacing={1}>
        <Grid item xs={2}>
          <Typography>التاريخ:</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography>{simpleDateFormatter(new Date())}</Typography>
        </Grid>
        <Grid item xs={8}></Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16 }}>الحساب:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography style={{ fontSize: 16, fontWeight: 'bold' }}>
            {isRTL ? account?.nameAr : account?.name}
          </Typography>
        </Grid>
        <Grid item xs={4}></Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16 }}>مدة التقرير:</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16, fontWeight: 'bold' }}>
            {simpleDateFormatter(start)}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16, fontWeight: 'bold' }}>
            {simpleDateFormatter(end)}
          </Typography>
        </Grid>
        <Grid item xs={6}></Grid>
        <Grid item xs={2}>
          <Typography style={{ fontSize: 16 }}>رصيد نهاية المدة:</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography style={{ fontSize: 16, fontWeight: 'bold' }}>
            {currencyFormatter({ value: rased })}
          </Typography>
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    );
  };

  render() {
    const {
      company,
      parentslist,
      isRTL,
      start,
      end,
      report,
      profit,
      totals,
      documentTitle,
      isTime,
    } = this.props;
    return (
      <Box>
        <div style={{ paddingLeft: 60, paddingRight: 40, direction: 'rtl' }}>
          {/* Text header - first page only (not fixed) */}
          <Box
            style={{
              textAlign: 'center',
              paddingTop: 30,
              paddingBottom: 10,
            }}
          >
            {company?.logo && (
              <img
                src={company?.logo}
                alt={company?.name}
                style={{
                  maxHeight: 80,
                  objectFit: 'contain',
                  marginBottom: 10,
                }}
              />
            )}
            <Typography
              style={{ fontWeight: 'bold', fontSize: 20, marginBottom: 4 }}
            >
              {isRTL ? company?.nameAr || company?.name : company?.name}
            </Typography>
            <Typography
              style={{ fontWeight: 'bold', fontSize: 18, marginBottom: 4 }}
            >
              {documentTitle}
            </Typography>
            {start && end && isTime && (
              <Typography variant="body2">
                {simpleDateFormatterData(start)} -{' '}
                {simpleDateFormatterData(end)}
              </Typography>
            )}
          </Box>
          <table id="report" className="report-container">
            <tbody className="report-content">
              <Box>
                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Divider></Divider>
                  </Grid>
                  {renderAccountHeaderCell(isRTL ? 'الرقم' : 'No', 1)}
                  {renderAccountHeaderCell(isRTL ? 'الرئيسي' : 'Main', 2)}
                  {renderAccountHeaderCell(isRTL ? 'الفرعي' : 'Sub', 2)}
                  {renderAccountHeaderCell(isRTL ? 'الحساب' : 'Account', 2)}
                  {renderAccountHeaderCell(isRTL ? 'مدين' : 'Debit', 1)}
                  {renderAccountHeaderCell(isRTL ? 'دائن' : 'Credit', 1)}
                  {renderAccountHeaderCell(
                    isRTL ? 'رصيد مدين' : 'Debit balance',
                    2,
                  )}
                  {renderAccountHeaderCell(
                    isRTL ? 'رصيد دائن' : 'Credit balance',
                    1,
                  )}
                </Grid>
                {parentslist.map((pacc: any) => {
                  return renderAccount({ pacc, isRTL });
                })}
                {report === 'bs' && (
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Divider></Divider>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={8}>
                      <Typography
                        variant="caption"
                        style={{ padding: 0, fontWeight: 'bold' }}
                      >
                        {isRTL ? 'قائمة الدخل' : 'Income Statment'}
                      </Typography>
                    </Grid>
                    {renderAccountCellbalance(
                      moneyFormatEmpty(profit?.debit),
                      2,
                    )}
                    {renderAccountCellbalance(
                      moneyFormatEmpty(profit?.credit),
                      1,
                    )}
                    <Grid item xs={12}>
                      <Divider></Divider>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={8}>
                      <Typography
                        color="secondary"
                        variant="caption"
                        style={{ padding: 0, fontWeight: 'bold' }}
                      >
                        {isRTL ? 'صافي ( الربح/الخسارة )' : 'Net Profit / Loss'}
                      </Typography>
                    </Grid>
                    {renderAccountHeaderCell(
                      moneyFormatEmpty(profit?.raseedd),
                      2,
                    )}
                    {renderAccountHeaderCell(
                      moneyFormatEmpty(profit?.raseedc),
                      1,
                    )}
                  </Grid>
                )}

                <Grid container spacing={0}>
                  <Grid item xs={12}>
                    <Divider></Divider>
                  </Grid>
                  <Grid item xs={1}></Grid>
                  <Grid item xs={8}></Grid>
                  {renderAccountHeaderCell(moneyFormatEmpty(totals?.debit), 2)}
                  {renderAccountHeaderCell(moneyFormatEmpty(totals?.credit), 1)}
                </Grid>
                {report === 'is' && (
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Divider></Divider>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7}>
                      <Typography
                        variant="caption"
                        color="secondary"
                        style={{ padding: 0, fontWeight: 'bold' }}
                      >
                        {isRTL ? 'صافي ( الربح/الخسارة )' : 'Net Profit / Loss'}
                      </Typography>
                    </Grid>
                    {renderAccountHeaderCell(
                      moneyFormatEmpty(profit?.raseedd),
                      2,
                    )}
                    {renderAccountHeaderCell(
                      moneyFormatEmpty(profit?.raseedc),
                      1,
                    )}
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Box m={6}></Box>
                </Grid>
              </Box>
            </tbody>
            <tfoot className="report-footer">
              <tr style={{ padding: 0, borderColor: '#fff', borderWidth: 0 }}>
                <td style={{ padding: 0, borderColor: '#fff', borderWidth: 0 }}>
                  <div className="footer-info">
                    <div
                      className="page-footer"
                      style={{ fontSize: 14, padding: 5 }}
                    >
                      {company?.name}
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
            {/* <div style={{ marginTop: 100 }}>After Footer</div> */}
          </table>
        </div>
      </Box>
    );
  }
}
